"use strict";
exports.__esModule = true;
exports.checkoutSelectors = exports.popupClass = void 0;
exports.popupClass = 'phone-autentication-popup';
exports.checkoutSelectors = {
    contactInformationDiv: '.section.section--contact-information',
    popup: '.' + exports.popupClass,
    submitPhoneBtn: '.phone-autentication-submit-phone-btn',
    submitCodeBtn: '.phone-autentication-submit-code-btn',
    emailBtnYes: '.phone-autentication-submit-email-btn-yes',
    emailBtnNo: '.phone-autentication-submit-email-btn-no',
    signMeInBtn: '.phone-autentication-submit-sign-in-btn',
    submitEmailUpdateBtn: '.phone-autentication-submit-email-update-btn',
    submitEmailCodeBtn: '.phone-autentication-submit-email-code-btn',
    phoneInput: '.phone-autentication-popup-phone-input2',
    codeInput: '.phone-autentication-popup-code-input',
    emailUpdateInput: '.phone-autentication-popup-email-update-input',
    emailCodeInput: '.phone-autentication-popup-email-code-input',
    popupTitle: '.phone-autentication-popup-title',
    popupText: '.phone-autentication-popup-text',
    step: '.phone-authentication-step',
    stepPhone: '.phone-authentication-step-phone',
    stepPhoneNotFound: '.phone-authentication-step-phone-not-found',
    stepCode: '.phone-authentication-step-code',
    stepEmail: '.phone-authentication-step-email',
    stepEmailUpdate: '.phone-authentication-step-email-update',
    stepEmailCode: '.phone-authentication-step-email-code',
    stepSignIn: '.phone-authentication-step-sign-in',
    noAccountLink: '.no-account-link',
    emailRetryLink: '.email-retry-link',
    defaultLoginLink: '.section--contact-information .layout-flex__item a',
    phoneNotFoundErrorMsg: '.phone-not-found-error-msg',
    continueWithoutLoggingInBtn: '.phone-autentication-continue-without',
    phoneNotFoundTryAgainBtn: '.phone-autentication-phone-not-found-try-again',
    shippingPhoneInput1: '.custom-phone-number-input1',
    shippingPhoneInput2: '.custom-phone-number-input2'
};
